import request from '@/axios/request';
//获得左侧菜单数据
export function getMenu(param) {
    return request({
      //api.Hallowmas 引用url.js里面的数据
      url: '/api/getRoleFunListByAccountId',
      method: 'get',//请求方法
      params:param
    })
  }
//获得组织机构树数据
export function getGroupTree(data) {
  return request({
    //api.Hallowmas 引用url.js里面的数据
    url: '/api/organizational/getOrganizationalManagementTree',
    method: 'get',//请求方法
    params:{
      groupId:data.groupId, //传过去的参数
      accountId: data.accountId
    }
  })
}
//查看组织套餐使用
export function checkSetMealUse(groupId) {
  return request({
    url:'/api/organizational/getOrganizationalCount',
    method:'get',
    params: {
      groupId: groupId
    }
  })
}
//添加组织——保存
export function addGroupInfo(data) {
  return request({
    url:'/api/organizational/addOrganizational',
    method:'post',
    data: data
  })
}
//添加组织——编辑
export function editGroupInfo(data) {
  return request({
    url:'/api/organizational/editOrganizational',
    method:'post',
    data: data
  })
}

//添加组织——删除
export function delGroupInfo(data) {
  return request({
    url:'/api/organizational/delOrganizational',
    method:'post',
    data: data
  })
}


//获取舆情分类管理列表
export function getMessageDimensions(groupId) {
    return request({
      url:'/api/dict/getMessageDimensions',
      method:'get',
      params: {
        groupId: groupId
      }
    })
  }


// WEBPACK FOOTER //
// ./src/api/orgment.js